export default function ($httpProvider) {
    'ngInject';

    // initialize get if not there
    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }

    // disable IE ajax request caching
    $httpProvider.defaults.headers.get['If-Modified-Since'] = '0';
    // extra
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
}



// WEBPACK FOOTER //
// ./src/js/config/httpProvider.js